import RivalsList from '../../../components/RivalsList'
import type { Rival } from '../../../types'
import DemoFrame from './DemoFrame'
import { demoNoop } from './demoFixtures'

/**
 * Two rivals with their head-to-head tallies, rendered through the real rivals list rather than
 * two loose avatars: the tally beside a face is the thing being explained, and this is the exact
 * row the user will meet on their own profile.
 */
const DEMO_RIVALS: Rival[] = [
  {
    userId: 'demo-rival-1',
    displayName: 'Marcus',
    avatarPreset: 'gaffer-1',
    record: { wins: 4, losses: 2, ties: 1 },
    createdAt: '2026-01-02T00:00:00.000Z',
  },
  {
    userId: 'demo-rival-2',
    displayName: 'Priya',
    avatarPreset: 'ultra-2',
    record: { wins: 1, losses: 3, ties: 0 },
    createdAt: '2026-01-01T00:00:00.000Z',
  },
]

export default function RivalsDemo() {
  return (
    <DemoFrame className="rules-demo--rivals">
      <RivalsList rivals={DEMO_RIVALS} collapsible={false} onViewProfile={demoNoop} />
    </DemoFrame>
  )
}
